import { format } from 'date-fns';

/** Como decidir a hora quando o chamador não tem uma. */
export interface ResolveTransactionTimeOptions {
    /**
     * `false` quando o lançamento vem de um ARQUIVO (OFX, PDF de fatura/extrato, CSV)
     * e não de uma ação acontecendo agora: sem hora no arquivo, fica SEM hora. Carimbar
     * o "agora" do import numa compra de hoje diria 22h numa compra das 14h — o import
     * é um registro histórico, não um acontecimento. Padrão `true`.
     */
    stampNow?: boolean;
}

/**
 * A HORA de um lançamento (`transactions.time`, 'HH:mm'), decidida por uma regra só:
 * a hora escolhida pelo usuário vence; sem ela, um lançamento que acontece HOJE
 * carimba o "agora" da efetivação e um de outro dia fica sem hora — "agora" seria
 * mentira num lançamento datado de ontem ou numa parcela que só vence em março.
 *
 * A hora é opcional por desenho: ela desempata o intra-dia no extrato e só APARECE
 * com a preferência "Hora nos lançamentos" ligada (showTransactionTime) — gravar é
 * sempre, exibir é opção.
 *
 * Use em todo caminho que EFETIVA dinheiro (formulário, recebimento de empréstimo,
 * pagamento de fatura, ajuste de saldo, marcar como pago). Não use em previsto que
 * nasce futuro (série de parcelas de financiamento, cronograma do "quem me deve"):
 * lá a data é um agendamento, não um acontecimento. Em IMPORTAÇÃO, passe
 * `{ stampNow: false }`: só a hora que veio no arquivo vale.
 */
export function resolveTransactionTime(
    date: string,
    explicitTime?: string | null,
    options?: ResolveTransactionTimeOptions,
): string | null {
    if (explicitTime) return explicitTime;
    if (options?.stampNow === false) return null;
    const now = new Date();
    return date === format(now, 'yyyy-MM-dd') ? format(now, 'HH:mm') : null;
}
